let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1c1XO"), load("dMWJp")]).then(() => parcelRequire('eTW2b'));